import Link from 'next/link';

import { mapProductSubCategoryToString } from '@lib/product/constants';
import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { HEADER_FILTERS } from '@lib/constants/navigations';
import { Button } from '@components/common/button';
import { Routes } from '@lib/routes';
import { slugify } from '@lib/utils';

interface ExpandedMenuFiltersProps {
  onClose: () => void;
}

export function ExpandedMenuFilters({ onClose }: Readonly<ExpandedMenuFiltersProps>) {
  const { category } = useHeaderStore();
  const filters = HEADER_FILTERS[category];

  if (!filters) return null;

  return (
    <div className="space-y-4 mt-2">
      {Object.entries(filters).map(([outerKey, outerValue]) => {
        if (typeof outerValue !== 'object' || outerValue === null) return null;

        // Sub-category filter
        if ('label' in outerValue && 'param' in outerValue) {
          return (
            <div key={outerKey} className="space-y-1">
              <h4 className='font-medium text-lg xl:text-xl'>{outerValue.label}</h4>
              <Button
                asChild
                variant="link"
                className='size-auto p-0 text-lg xl:text-xl text-accent/80 hover:text-accent'
                onClick={onClose}
              >
                <Link href={`${Routes.collection}?subCategory=${outerValue.param}`}>
                  All {outerValue.label}
                </Link>
              </Button>
            </div>
          );
        }

        // Identifier filter
        const subCategoryLabel = mapProductSubCategoryToString(Number(outerKey));

        return (
          <div key={outerKey} className="flex flex-col items-start gap-y-1">
            <h4 className='font-medium text-lg xl:text-xl whitespace-nowrap'>{subCategoryLabel}</h4>
            {Object.entries(outerValue).map(([innerKey, innerValue]) => {
              if (
                typeof innerValue !== 'object' ||
                innerValue === null ||
                !('label' in innerValue && 'param' in innerValue)
              )
                return null;

              return (
                <Button
                  key={innerKey}
                  asChild
                  variant="link"
                  className="size-auto p-0 text-lg xl:text-xl"
                  onClick={onClose}
                >
                  <Link href={`${Routes.collection}?identifiers=${innerValue.param}`}>
                    {String(innerValue.label)}
                  </Link>
                </Button>
              );
            })}
            <Button
              asChild
              variant="link"
              className="size-auto p-0 text-lg xl:text-xl text-accent/80 hover:text-accent"
              onClick={onClose}
            >
              <Link href={`${Routes.collection}?subCategory=${slugify(subCategoryLabel)}`}>
                All {subCategoryLabel}
              </Link>
            </Button>
          </div>
        );
      })}
    </div>
  );
}
